import React, { memo } from 'react'
import Icon from '../../core/Icon/ContentfulIcon'

import type { Entry } from 'contentful'
import { TypeIconWithoutUnresolvableLinksResponse } from 'contentful-types'

type IconProps = {
  icon: TypeIconWithoutUnresolvableLinksResponse
}

const MemoIcon = ({ icon }: IconProps) => {
  return <Icon {...(icon as Entry<any>)} />
}

export default memo(MemoIcon)
